<div class="header-tab" [ngClass]="{'selected': selected}" (click)="selectTabbed()">
    <sc-flex [fitHeight]="true">
        <div class="label">{{structure.title}}</div>
        <sc-content-spacer *ngIf="selected"></sc-content-spacer>
        <div class="close-action" *ngIf="selected"><sc-icon iconClass="fa-times close-btn" (click)="closeTabbed()"></sc-icon></div>
    </sc-flex>
</div>